import SgdfParticipantCard from './participant-card.component.js';
export * from './participant-card.component.js';
export default SgdfParticipantCard;
SgdfParticipantCard.define('sgdf-participant-card');
//# sourceMappingURL=participant-card.js.map